import "@/components/ArticleImage.css";

export function ArticleImage({ image, hero = false }) {
  if (!image) return null;
  return <figure className={`article-image ${hero ? "article-image-hero" : "article-image-section"}`} data-testid={`article-image-${image.role}`}>
    <div className="article-image-frame"><img src={image.src} alt={image.alt || image.query} loading={hero ? "eager" : "lazy"}/></div>
    <figcaption>Photo by <a href={image.photographer_url} target="_blank" rel="noreferrer" data-testid={`photographer-credit-${image.role}`}>{image.photographer}</a> on <a href={image.unsplash_url} target="_blank" rel="noreferrer" data-testid={`unsplash-credit-${image.role}`}>Unsplash</a></figcaption>
  </figure>;
}
